import { render, staticRenderFns } from "./PasswordResetPage.vue?vue&type=template&id=1848eac4&scoped=true"
import script from "./PasswordResetPage.vue?vue&type=script&lang=ts"
export * from "./PasswordResetPage.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetPage.vue?vue&type=style&index=0&id=1848eac4&prod&lang=scss&scoped=true"
import style1 from "./PasswordResetPage.vue?vue&type=style&index=1&id=1848eac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1848eac4",
  null
  
)

export default component.exports